export default __webpack_public_path__ + "static/media/japangot-screenshot-03.62a76059.png";